export enum MerchantLoginAction {
  TOKEN_ISSUED = "TOKEN_ISSUED",
  PASSWORD_CHANGE_REQUIRED = "PASSWORD_CHANGE_REQUIRED",
  OTP_REQUIRED = "OTP_REQUIRED",
}

export interface MerchantLoginModel {
  action: MerchantLoginAction;
  // when TOKEN_ISSUED:
  tokenType?: string;
  accessToken?: string;
  refreshToken?: string;
  expiresIn?: number;
  // when PASSWORD_CHANGE_REQUIRED:
  sessionToken?: string;
  redirect?: string;
  // when OTP_REQUIRED:
  channel?: string;
  otpExpiresIn?: number;
  resendCooldownSeconds?: number;
}

export interface MerchantForgotPasswordVerifyOtpModel {
  resetSessionToken: string;
  expiresIn: number;
}

export interface MerchantChangePasswordVerifyModel {
  sessionId: string;
  token: string;
  expiresIn: number;
}
